import React from 'react';

import s from './style.module.css';
import { MemberShipProps, PriceTableProps } from '../../../props';
import { priceFormat, totalBudgetFormat, calcTotalBudgetWithCommission } from '@Util/util';
import PriceVersionNote from '@Pages/Detail/components/price_version_note/view';

const BuyingPriceTable = (props: MemberShipProps) => {
    return (
        <div className={s.head_2_body}>
            <table className={s.price_table}>
                <tbody>
                    {props.memberships.map((membership) => (
                        <PriceTable key={`memberships-${membership.id}`} membership={membership} isJpy={props.isJpy} />
                    ))}
                </tbody>
            </table>
            <PriceVersionNote memberships={props.memberships} />
        </div>
    );
};

const PriceTable = (props: PriceTableProps) => {
    const membership = props.membership;
    const displayNumberOfSellingOffers = !membership.isInitialOffering || membership.numberOfSellingOffers;
    const priceUnit = props.isJpy ? '万円' : 'THB';
    const totalBudget = membership.isInitialOffering
        ? membership.totalBudget
        : calcTotalBudgetWithCommission(membership.totalBudget, membership.sellingPrice);

    return (
        <>
            <tr>
                <th>会員種別</th>
                <th>
                    {membership.isInitialOffering ? (
                        <>
                            入会金
                            <span className={s.price_table_supplement}>
                                {displayNumberOfSellingOffers ? '（定員）' : ''}
                            </span>
                        </>
                    ) : (
                        <>
                            売希望最安値<span className={s.price_table_supplement}>（件数）</span>
                        </>
                    )}
                </th>
                <th>名義書換料</th>
                <th>入会預託金</th>
                <th>年会費</th>
                <th>購入総額概算</th>
            </tr>
            <tr>
                <td>
                    {membership.name || membership.membershipType || '-'}
                    {membership.isInitialOffering && '（新規募集）'}
                </td>
                <td>
                    {membership.isAsk ? 'ご相談' : priceFormat(membership.sellingPrice, priceUnit)}
                    {displayNumberOfSellingOffers ? (
                        <span className={s.price_table_supplement}>
                            （{membership.numberOfSellingOffers}
                            {membership.isInitialOffering ? '名' : '件'}）
                        </span>
                    ) : (
                        ''
                    )}
                </td>
                <td>{membership.isInitialOffering ? '-万円' : priceFormat(membership.registrationFee, priceUnit)}</td>
                <td>{priceFormat(membership.deposit, priceUnit)}</td>
                <td>{priceFormat(membership.annualFee, props.isJpy ? '円' : 'THB')}</td>
                <td>
                    {membership.isAsk
                        ? 'ご相談'
                        : `${totalBudgetFormat(
                              totalBudget,
                              membership.numberOfSellingOffers,
                              membership.isInitialOffering
                          )}${priceUnit}`}
                </td>
            </tr>
        </>
    );
};

export default BuyingPriceTable;
